<pm-button ButtonClass="button-sidenav" (click)="ToggleSidenav()">
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 18 18" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
        <path d="M0 0h18v18h-18z" fill="none"></path>
        <path d="M2 13.5h14v-1.5h-14v1.5zm0-4h14v-1.5h-14v1.5zm0-5.5v1.5h14v-1.5h-14z"></path>
    </svg>
</pm-button>
<div *ngIf="IsSidenavOpen" 
     class="sidenav-content">
    <ng-content></ng-content>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/sidenav/sidenav.html